export default "__VITE_ASSET__z6ifkE$x__"